import { Constants } from "../../Utils/Constants";
import { Language, Messages } from '../Language'
import { PasswordCallback, PasswordEngine } from "./PasswordDialog";

export class PinCode implements PasswordEngine {
    constructor(private scene: Phaser.Scene) {
        this.Callback = () => { }
        this.dom = this.scene.add.dom(0, 0).createFromHTML(this.html)

        // See snippet for a description
        // Must be pointerdown due to the event processing order in Phaser
        // Some previous iOS Safari versions do not support pointer events
        this.dom.addListener('click')
        this.dom.on('click', this.handler, this)

        this.dom.setVisible(false)
        this.OnResize(this.scene.scale.width, this.scene.scale.height)
    }

    BringToTop(): void {
        this.scene.children.bringToTop(this.dom)
    }

    Show(message?: string, subtitleMessage?: string, lowerMessage?: string, mainTitleMessage?: string): void {
        let pinInputField = this.dom.getChildByID("numpad-display") as HTMLInputElement
        let subTitle = this.dom.getChildByID("helper-text") as HTMLDivElement
        let bottomText = this.dom.getChildByID("bottom-text") as HTMLDivElement
        let mainTitle = this.dom.getChildByID("main-title-text") as HTMLDivElement

        pinInputField.value = ""
        pinInputField.placeholder = Language.Get(Messages.ENTER_PIN)
        subTitle.innerText = "A"
        bottomText.innerText = "A"
        mainTitle.innerText = "A"

        subTitle.style.display = "block"
        bottomText.style.display = "block"
        mainTitle.style.display = "block"

        subTitle.style.visibility = "visible"
        bottomText.style.visibility = "visible"
        mainTitle.style.visibility = "visible"

        if (message) pinInputField.placeholder = message

        if (subtitleMessage) subTitle.innerText = subtitleMessage
        else subTitle.style.visibility = "hidden"
        // else subTitle.style.display = "none"

        if (lowerMessage) bottomText.innerText = lowerMessage
        else bottomText.style.visibility = "hidden"
        // else bottomText.style.display = "none"

        if (mainTitleMessage) mainTitle.innerText = mainTitleMessage
        else mainTitle.style.visibility = "hidden"

        this.Resize(this.scene.scale.width, this.scene.scale.height)

        this.dom.node.parentElement.style.zIndex = "1"
        this.dom.setVisible(true)
    }

    Hide(): void {
        this.dom.setVisible(false)
    }

    Resize(width: number, height: number): void {
        this.OnResize(width, height)
    }

    OnResize(width: number, height: number): void {

        let widthScale = (width * 0.9) / this.dom.displayWidth / window.devicePixelRatio
        let heightScale = (height * 0.9) / this.dom.displayHeight / window.devicePixelRatio
        this.dom.setPosition(width / 2, height / 2)
        try {
            switch (window.orientation) {
                case 0:
                case 180://portrait
                    this.dom.setPosition(width / 2, - this.dom.displayHeight)
                    widthScale = (height * 0.9) / this.dom.displayHeight / window.devicePixelRatio
                    heightScale = (width * 0.9) / this.dom.displayWidth / window.devicePixelRatio
                    break;
                case -90:
                case 90:
                default: //landscape
                    break;
            }
        }
        catch {
        }

        this.dom.setScale(Math.min(widthScale, heightScale))
    }

    UpdateCallback(callback: PasswordCallback): void {
        this.Callback = callback
    }

    private handler(event: any) {
        event.stopImmediatePropagation()
        event.stopPropagation()
        event.preventDefault()

        if (event.target.className == "numpad-btn" || event.target.className == "numpad-btn ng" || event.target.className == "numpad-btn green") {
            this.scene.sound.play(Constants.SOUNDS.BUTTON_PRESS_SOFT)

            let id = event.target.id
            let value = event.target.innerHTML
            let pinInputField = this.dom.getChildByID("numpad-display") as HTMLInputElement
            let cancelOrEraseButton = this.dom.getChildByID("numpad_CLR") as HTMLDivElement

            if (id == "numpad_RTN") {
                cancelOrEraseButton.innerText = "X"
                this.Callback(pinInputField.value)
                return
            }

            if (value == "X") {
                pinInputField.value = ""
                this.Callback(null)
                return
            }
            else if (value == "C") {
                pinInputField.value = ""
                cancelOrEraseButton.innerText = "X"
            } else if (value == "1" || value == "2" || value == "3" || value == "4" || value == "5" || value == "6" || value == "7" || value == "8" || value == "9" || value == "0") {
                pinInputField.value += value
                cancelOrEraseButton.innerText = "C"
            } else {
                let length = pinInputField.value.length
                if (length > 0) pinInputField.value = pinInputField.value.substring(0, length - 1)
            }

            /*
            if(pinInputField.value.length == 4) {
                this.Callback(pinInputField.value)
                pinInputField.value = "****"
            }
            */
        }
    }

    Callback: PasswordCallback
    private dom: Phaser.GameObjects.DOMElement
    private html = `<style>
                    #numpad-wrap, #numpad-display {
                        font-family: 'Arial', sans-serif;
                        touch-action: none;
                    }
                    #numpad-wrap {
                        max-width: 320px;
                        margin: 0 auto;
                        padding: 10px;
                        background: #f2f2f2;
                        border: 1px solid #ccc;
                    }
                    
                    #numpad-display {
                        box-sizing: border-box;
                        width: 100%;
                        padding: 5px;
                        font-size: 1em;
                        text-align: center;
                        margin-bottom: 10px;
                    }
                    
                    #numpad-btns {
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                    }
                    .numpad-btn {
                        box-sizing: border-box;
                        width: 33%;
                        padding: 10px;
                        border: 1px solid #aaa;
                        background: #444;
                        color: #fff;
                        text-align: center;
                        font-size: 1.5em;
                        -webkit-touch-callout: none; /* iOS Safari */
                        -webkit-user-select: none; /* Safari */
                        -khtml-user-select: none; /* Konqueror HTML */
                        -moz-user-select: none; /* Firefox */
                        -ms-user-select: none; /* Internet Explorer/Edge */
                        user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
                    }
                    .numpad-btn:active {
                        background-color: grey;
                    }
                    .numpad-btn.zero {
                        width: 50%;
                    }
                    .numpad-btn.zero:active {
                        background-color: grey;
                    }
                    .numpad-btn.zeroN {
                        width: 75%;
                    }
                    .numpad-btn.ninja {
                        display: none;
                    }
                    .numpad-btn.ng {
                        background: #333;
                    }
                    .numpad-btn.ng:active {
                        background-color: grey;
                    }
                    .numpad-btn.green {
                        color: #FFFFFF;
                        background: #00AA00;
                    }
                    .numpad-btn.green:active {
                        color: #FFFFFF;
                        background: #00FF00;
                    }
                    .numpad-btn.cx {
                        background: #B23025;
                        border: 1px solid #C73D32;
                    }
                    .numpad-btn.ok {
                        background: #1FA83A;
                        border: 1px solid #1FC72D;
                    }
                    .numpad-btn:hover {
                        cursor: pointer;
                    }
                    #title-bar {
                        font-size: 16px;
                        color: white;
                        text-align: center;
                    }
                    #main-title-text {
                        font-size: 20px;
                        color: white;
                        text-align: center;
                        padding-top: 10px;
                        padding-bottom: 10px;
                        font-family: 'Arial', sans-serif;
                        touch-action: none;
                    }
                    #helper-text {
                        font-size: 16px;
                        color: white;
                        text-align: center;
                        padding-top: 10px;
                        padding-bottom: 10px;
                        font-family: 'Arial', sans-serif;
                        touch-action: none;
                    }
                    #bottom-text {
                        font-size: 16px;
                        color: white;
                        text-align: center;
                        padding-top: 10px;
                        padding-bottom: 10px;
                        margin-bottom: 20px;
                        font-family: 'Arial', sans-serif;
                        touch-action: none;
                    }
                </style>

                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="main-title-text" class="unselectable">
                    
                </div>
                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="helper-text" class="unselectable">

                </div>
                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad-back" class="show" class="unselectable">
                    <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad-wrap" class="unselectable">
                        <input unselectable="on" id="numpad-display" type="password" placeholder="${Language.Get(Messages.ENTER_PIN)}" readonly="" class="unselectable">
                            <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad-btns" class="unselectable">
                                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad_7" class="numpad-btn">1</div>
                                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad_8" class="numpad-btn">2</div>
                                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad_9" class="numpad-btn">3</div>
                                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad_4" class="numpad-btn">4</div>
                                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad_5" class="numpad-btn">5</div>
                                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad_6" class="numpad-btn">6</div>
                                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad_1" class="numpad-btn">7</div>
                                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad_2" class="numpad-btn">8</div>
                                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad_3" class="numpad-btn">9</div>
                                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad_CLR" class="numpad-btn ng">X</div>
                                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad_0" class="numpad-btn">0</div>
                                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="numpad_RTN" class="numpad-btn green">&#10003;</div>
                            </div>
                        </div>
                </div>
                <div unselectable="on" onselectstart="return false;" onmousedown="return false;" id="bottom-text" class="unselectable">

                </div>
                `
}